import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRepeat"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H22V19H14.4142L16.4142 21L15 22.4142L10.5858 18L15 13.5858L16.4142 15L14.4142 17H20V5H4V17H8V19H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRepeat;
